import {toast} from 'react-toastify'
import "./style.css"

const toaster = (type: string, message: string) => {
  if (type === 'success') toast.success(message)
  else if (type === 'error') toast.error(message)
  else if (type === 'warning') toast.warning(message)
  else if (type === 'info') toast.info(message)
}
export default toaster
